import React from 'react'

function ListPeriodsheader() {
    return (
        <thead className='thead-light ListPeriodsheader'>
            <tr>
                <th className='name'>Tên lô</th>
                <th className='type'>Loại sản phẩm</th>
                <th className='stage'>Công đoạn</th>
                <th className='quanlity'>Số lượng</th>
                <th className='user'>Người thực hiện</th>
                <th className='time'>Thời gian</th>
            </tr>
        </thead>
    )
}

export default ListPeriodsheader